import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const StyledText = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  ${Styles.FontStyles}
  text-align: ${({ styleProps }) => styleProps?.textAlign || 'left'};
  justify-content: ${({ styleProps }) => styleProps?.textAlign || 'left'};
  background-color: ${({ styleProps }) => styleProps?.backgroundColor};
  white-space: normal;
  text-overflow: ellipsis;

  & > div {
    width: 100%;
    height: 100%;
  }
`;